export const radiusOptions = [
  {
    value: 5,
    label: "5"
  },
  {
    value: 10,
    label: "10"
  },
  {
    value: 25,
    label: "25"
  },
  {
    value: 50,
    label: "50"
  },
  {
    value: 100,
    label: "100"
  },
  {
    value: 250,
    label: "250"
  }
];

export const defaultRadiusOption = {
  value: 10,
  label: "10 Miles"
};

const specialties = [
  { label: "Primary Care Physician", value: "general" },
  { label: "Dermatologist", value: "dermatology" },
  { label: "Optometry", value: "optometry" },
  { label: "Obstetrics & Gynecology", value: "obstetrics and gynecology" },
  { label: "Orthopedic Surgery", value: "orthopedic" },
  { label: "Psychiatry", value: "psychiatry" },
  { label: "Counseling", value: "counselor" },
  { label: "Otolaryngology", value: "otolaryngology" },
  { label: "Pediatricians", value: "family medicine" },
  { label: "Psychology", value: "psychologist" },
  { label: "Podiatry", value: "podiatrist" },
  { label: "Ophthalmology", value: "ophthalmology" },
  { label: "Neurology", value: "neurology" },
  { label: "Gastroenterology", value: "gastroenterology" },
  { label: "Allergy/Immunology", value: "allergy" },
  { label: "Cardiology", value: "cardiology" },
  { label: "No Preference", value: "no-preference" },
  { label: "Other", value: "other" },
  { label: "Cancel", value: "" }
];

export const providerSpecialties = specialties.sort((a, b) => {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
});

export const gender = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "All", label: "No preference" }
];

export const defaultGenderOption = {
  value: "All",
  label: "No preference"
};

export const PROVIDER_TOAST_ID = "__FIND_PROVIDER__";

export const providerMessages = {
  NO_PROVIDERS: "No providers found. Please, update search params.",
  ZIP_REQUIRED: "Zip code is required.",
  FETCHING_ERROR: "Error fetching data."
};

export const zipRegex = /\b\d{5}\b/;
